import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";

import { useDispatch, useSelector } from "react-redux";
import {
  deleteGovernoratesService,
  getAllgovernoratesService,
  createGovernoratesService,
  updateGovernoratesService,
  createAreaService,
} from "redux/services/general_service";
import { toast } from "react-toastify";
import { useLanguage } from "../../LanguageContext";
import GovernrateTable from "./components/GovernrateTable";
import AddGovernorateModal from "./components/AddGovernorateModal";
import EditGovernorateModal from "./components/EditGovernorateModal";
import AddAreaModal from "./components/AddAreaModal"; // سننشئ هذا المكون أدناه
import Button from "components/ui/Button";

const GovernoratesManagement = () => {
  const dispatch = useDispatch();
  const { language } = useLanguage();

  const [selectedClients, setSelectedClients] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    status: "All",
    dateRange: { start: "", end: "" },
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAddAreaModalOpen, setIsAddAreaModalOpen] = useState(false);
  const [selectedGovernorateForArea, setSelectedGovernorateForArea] =
    useState(null); // state للمحافظة المحددة لإضافة منطقة
  const [editingGovernorate, setEditingGovernorate] = useState(null);

  const { governoratesList } = useSelector((state) => state.general);

  // Translations
  const translations = {
    governoratesManagement:
      language === "ar" ? "إدارة المحافظات" : "Governorates Management",
    manageGovernorates:
      language === "ar"
        ? "إدارة ومراقبة جميع المحافظات"
        : "Manage and monitor all governorates",
    addNewGov: language === "ar" ? "إضافة محافظة جديدة" : "Add New Governorate",
    totalGovernorates:
      language === "ar" ? "إجمالي المحافظات" : "Total Governorates",
    active: language === "ar" ? "نشط" : "Active",
    endingSoon: language === "ar" ? "ينتهي قريباً" : "Ending Soon",
    expired: language === "ar" ? "منتهي" : "Expired",
  };

  const itemsPerPage = 6;

  const handlePageChange = (page) => {
    console.log(`Changing to page: ${page}`);
    setCurrentPage(page);
    dispatch(getAllgovernoratesService({ page: page }));
  };

  const handleSelectAll = (checked) => {};

  const handleSelectClient = (clientId, checked) => {
    if (checked) {
      setSelectedClients((prev) => [...prev, clientId]);
    } else {
      setSelectedClients((prev) => prev.filter((id) => id !== clientId));
    }
  };

  const handleDeleteClient = (clientId) => {
    dispatch(deleteGovernoratesService(clientId)).then((response) => {
      if (
        response.payload?.status === 200 ||
        response.payload?.status === 201 ||
        response.payload?.status === 204
      ) {
        toast.success(
          language === "ar" ? "تم الحذف بنجاح" : "Deleted successfully",
        );
        dispatch(getAllgovernoratesService({ page: 1 }));
      }
    });
  };

  const handleRenewSubscription = (clientId) => {
    console.log("Renewing subscription for client:", clientId);
  };

  const handleBulkAction = (action) => {
    console.log(`Performing ${action} on clients:`, selectedClients);
    if (action === "delete") {
      setSelectedClients([]);
    }
  };

  const handleAddGovernorate = (name) => {
    dispatch(createGovernoratesService({ name })).then((response) => {
      if (
        response.payload?.status === 200 ||
        response.payload?.status === 201
      ) {
        toast.success(
          language === "ar" ? "تم الإضافة بنجاح" : "Added successfully",
        );
        setIsAddModalOpen(false);
        dispatch(getAllgovernoratesService({ page: 1 }));
      }
    });
  };

  const handleEditGovernorate = (governorate) => {
    setEditingGovernorate(governorate);
    setIsEditModalOpen(true);
  };

  const handleUpdateGovernorate = (id, name) => {
    dispatch(
      updateGovernoratesService({
        id: id,
        data: { translations: { ar: { name: name } } },
      }),
    ).then((response) => {
      if (
        response.payload?.status === 200 ||
        response.payload?.status === 201
      ) {
        toast.success(
          language === "ar" ? "تم التعديل بنجاح" : "Updated successfully",
        );
        setIsEditModalOpen(false);
        setEditingGovernorate(null);
        dispatch(getAllgovernoratesService({ page: 1 }));
      }
    });
  };

  const handleAddArea = (governorate) => {
    setSelectedGovernorateForArea(governorate);
    setIsAddAreaModalOpen(true);
  };

  const handleConfirmAddArea = (name) => {
    dispatch(
      createAreaService({
        translations: { ar: { name: name }, en: { name: name } },
        country_id: selectedGovernorateForArea.id,
      }),
    ).then((response) => {
      if (
        response.payload?.status === 200 ||
        response.payload?.status === 201
      ) {
        toast.success(
          language === "ar"
            ? "تم إضافة المنطقة بنجاح"
            : "Area added successfully",
        );
        setIsAddAreaModalOpen(false);
        setSelectedGovernorateForArea(null);
        // يمكن إعادة تحميل المحافظات إذا كانت المناطق مرتبطة، أو تحميل قائمة المناطق إذا كانت منفصلة
      }
    });
  };

  useEffect(() => {
    dispatch(getAllgovernoratesService({ page: 1 }));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-6">
        <div className="mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mt-12">
            <div>
              <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">
                {translations.governoratesManagement}
              </h1>
              <p className="text-gray-600">{translations.manageGovernorates}</p>
            </div>

            <Button
              onClick={() => setIsAddModalOpen(true)}
              className="inline-flex items-center px-4 py-2 text-white font-medium rounded-lg hover:bg-green-700 transition-colors duration-200"
            >
              <Icon name="Plus" size={20} className="mr-2" />
              {translations.addNewGov}
            </Button>
          </div>
        </div>

        {/* GOVR Table */}
        <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
          <GovernrateTable
            clients={governoratesList}
            selectedClients={selectedClients}
            onSelectAll={handleSelectAll}
            onSelectClient={handleSelectClient}
            onDeleteClient={handleDeleteClient}
            onEditClient={handleEditGovernorate}
            onAddArea={handleAddArea} // إضافة prop لإضافة منطقة
            onRenewSubscription={handleRenewSubscription}
          />

          {/* Pagination */}
          {/*metaClient?.total > 9 && (
              <Pagination
                currentPage={metaClient?.current_page}
                totalPages={metaClient?.last_page}
                onPageChange={handlePageChange}
              />
            )*/}
        </div>
      </div>

      {/* Add Governorate Modal */}
      <AddGovernorateModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onConfirm={handleAddGovernorate}
        language={language}
      />

      {/* Edit Governorate Modal */}
      <EditGovernorateModal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setEditingGovernorate(null);
        }}
        onConfirm={handleUpdateGovernorate}
        governorate={editingGovernorate}
        language={language}
      />

      {/* Add Area Modal */}
      <AddAreaModal
        isOpen={isAddAreaModalOpen}
        onClose={() => {
          setIsAddAreaModalOpen(false);
          setSelectedGovernorateForArea(null);
        }}
        onConfirm={handleConfirmAddArea}
        governorate={selectedGovernorateForArea}
        language={language}
      />
    </div>
  );
};

export default GovernoratesManagement;
